import AuthInterceptor from './authInterceptor';

const baseURL = import.meta.env.VITE_API_URL;

const authInterceptor = new AuthInterceptor(baseURL);
const axiosInstance = authInterceptor.getInstance();

export { axiosInstance, authInterceptor };
